import { render, staticRenderFns } from "./InfosetsOverviewItem.vue?vue&type=template&id=6678f27e&"
import script from "./InfosetsOverviewItem.vue?vue&type=script&lang=ts&"
export * from "./InfosetsOverviewItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports